import {FC, PropsWithChildren, useMemo} from "react";
import {useGameServerAuto} from "@hooks/selectors/game.selectors";
import {GameServerProvider} from "./context";
import {injectChild} from "@constructor/functions";

interface GameServerContextProps {
    game_id?: number | string;
}

interface GameServerContextChildProps {
    game_id?: number | string;
}

const GameServerContext: FC<PropsWithChildren<GameServerContextProps>> = ({children, game_id}) => {

    const game = useGameServerAuto(game_id);
    
    const data = useMemo<GameServerContextChildProps>(() => ({
        game_id: game?.id
    }), [game?.id]);

    return (
        <GameServerProvider value={game}>
            {injectChild(data, children)}
        </GameServerProvider>
    )
}

export default GameServerContext;